export default "__VITE_ASSET__R1_ef_RZ__"